module.exports = __webpack_public_path__ + "assets/img/pageNotFound.fed91586.svg";